<ion-card
  style="width: calc(100%); height: calc(100%); display: flex; flex-direction: column"
  class="tcc-detail-card"
>
  <ion-card-header>
    <ion-card-title
      style="display: flex; flex-direction: row; justify-content: space-between; align-items: center"
      [color]="headerTextColor"
    >
      <div style="display: flex; flex-direction: row;">
        <div
          style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px;"
        >
          <fa-icon [icon]="['fal', iconName]"></fa-icon>
        </div>
        <div style="display: flex; flex-direction: row; flex; align-items: center; height: 40px;">
          <h5>{{ title }}</h5>
        </div>
      </div>
      <ion-buttons>
        <ion-button *ngFor="let btn of buttons" (click)="btn.func()" [color]="btn.color || 'primary'" mode="ios">
          <fa-icon
            *ngIf="btn.icon"
            [slot]="btn.text ? 'start' : 'icon-only'"
            [style.padding-right]="btn.text ? '8px' : ''"
            [icon]="['fal', btn.icon]"
            [size]="buttonSize"
          ></fa-icon>
          <ion-label *ngIf="btn.text">
            {{ btn.text }}
          </ion-label>
        </ion-button>
        <ng-container *ngIf="displayActions">
          <ion-button [fill]="buttonFill" [id]="'cardMenu-' + cardId" *ngIf="displayMenu">
            <fa-icon slot="icon-only" [icon]="['fal', 'ellipsis-stroke-vertical']" [size]="buttonSize"></fa-icon>
          </ion-button>
          <ion-button [fill]="buttonFill" color="primary" (click)="add()" *ngIf="displayAdd">
            <fa-icon slot="icon-only" [icon]="['fal', 'plus']" [size]="buttonSize"></fa-icon>
          </ion-button>
          <ion-button [fill]="buttonFill" color="primary" (click)="edit()" *ngIf="displayEdit">
            <fa-icon slot="icon-only" [icon]="['fal', 'pen-to-square']" [size]="buttonSize"></fa-icon>
          </ion-button>
          <ion-button [fill]="buttonFill" color="danger" (click)="delete()" *ngIf="displayDelete">
            <fa-icon slot="icon-only" [icon]="['fal', 'trash-can']" [size]="buttonSize"></fa-icon>
          </ion-button>
        </ng-container>
      </ion-buttons>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="ion-padding" style="overflow-y: auto">
    <ng-content></ng-content>
  </ion-card-content>
</ion-card>

<ion-popover [trigger]="'cardMenu-' + cardId" triggerAction="click" [dismissOnSelect]="true" *ngIf="displayMenu">
  <ng-template>
    <ion-content class="ion-background-overlay">
      <ng-content select="[slot=menu]"></ng-content>
    </ion-content>
  </ng-template>
</ion-popover>
